module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_saas-almagell-448b652f6a4ccb917a18870d4ff4e4fb.png";